import { faComment, faFlask, faMagnifyingGlass, faMessage, faNoteSticky, faTimeline, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { use, useContext, useEffect, useState } from 'react';
import { Accordion, Spinner } from 'react-bootstrap';

import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import { UserPreferencesContext } from '../../../Contexts/UserPreferencesContext';
import { Section } from '../../../Types/Section';
import CommentsSection from '../LotDetailsComponents/CommentsSection';
import GenealogySection from '../LotDetailsComponents/GenealogySection';
import GradingCommentsSection from '../LotDetailsComponents/GradingCommentsSection';
import LabResultsSection from '../LotDetailsComponents/LabResultsSection';
import QIRSection_QIRMS from '../LotDetailsComponents/QIRSection_QIRMS';
import QualitiesSection from '../LotDetailsComponents/QualitiesSection';
import LotDetailSummary from '../LotDetailsComponents/Summary';
import WarningsSection from '../LotDetailsComponents/WarningsSection';
import { LotDetailSection } from '../LotDetailSection';
import { SectionNavigation } from '../SectionNavigation';

function LotDetails_BAPP() {
    const { lotDetail } = useContext(LotDetailContext);
    const { userPreferences, loading: userPreferencesLoading, setActiveSections } = use(UserPreferencesContext);
    const [loading, setLoading] = useState(false);

    const sections: Section[] = [
        { name: 'warnings', title: 'LotDetails.Warnings.Title', icon: faTriangleExclamation, component: <WarningsSection /> },
        { name: 'QIRMSqirs', title: 'LotDetails.QIRs.Title', icon: faNoteSticky, component: <QIRSection_QIRMS showCreateQIRButton={true} /> },
        { name: 'qualities', title: 'LotDetails.Qualities.Title', icon: faMagnifyingGlass, component: <QualitiesSection /> },
        { name: 'labresults', title: 'LotDetails.LabResults.Title', titleSuffix: `${lotDetail.labResults.length}`, icon: faFlask, component: <LabResultsSection isRailCarSite={true} /> },
        { name: 'genealogy', title: 'LotDetails.Genealogy.Title', icon: faTimeline, component: <GenealogySection /> },
        { name: 'gradingcomments', title: 'LotDetails.GradingComments.Title', icon: faComment, component: <GradingCommentsSection /> },
        { name: 'comments', title: 'LotDetails.Comments.Title', icon: faMessage, component: <CommentsSection /> },
    ];

    const [defaultActiveSections, setDefaultActiveSections] = useState(sections.map(section => section.name));
    useEffect(() => {
        if (userPreferences?.lotDetail?.activeSections) {
            setDefaultActiveSections(userPreferences?.lotDetail?.activeSections);
        }
    }, [userPreferences?.lotDetail?.activeSections]);

    if (userPreferencesLoading) {
        return (
            <div className="d-flex justify-content-center mb-3">
                <Spinner animation="border" />
            </div>
        );
    }

    return (lotDetail &&
        <>
            <LotDetailSummary setLoading={setLoading} />

            <SectionNavigation sections={sections} />

            <Accordion activeKey={defaultActiveSections} onSelect={(eventKey) => setActiveSections(eventKey as string[])} alwaysOpen className="mb-2">
                {sections.map(section =>
                    <LotDetailSection
                        key={section.name}
                        name={section.name}
                        icon={section.icon}
                        title={section.title}
                        titleSuffix={section.titleSuffix}
                        component={section.component} />)
                }
            </Accordion>
        </>

    );
}

export default LotDetails_BAPP;